import React from 'react';
import { Grid } from '@mui/material';
import { AwardTemplate } from 'components/customers/models/Award';
import { CardViewTextRow } from 'ui/viewComponents';
import { isRewardEarnedAction } from '../models/Action';
import { getActionDate } from '../utils/formatDate';
import { ActionCardBase } from './ActionCardBase';
import { ActionCardModalComponentProps } from './ActionCardModalComponent';

export const ActionCardLoyaltyEarned: React.FC<ActionCardModalComponentProps> = ({ action, perks }) => {
    if (!isRewardEarnedAction(action)) {
        return <ActionCardBase action={action} broken />;
    }
    const perk =
        action.metadata.perkId &&
        Array.isArray(perks) &&
        perks.find(item => item._id === action.metadata.perkId);
    const { pointsAdded } = action.metadata;
    return (
        <ActionCardBase action={action}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CardViewTextRow title="Date" value={getActionDate(action)} />
                </Grid>

                {perk && (
                    <Grid item xs={12}>
                        <CardViewTextRow title="Name" value={perk.title} />
                    </Grid>
                )}
                {perk && perk.template === AwardTemplate.STAMP_CARD && (
                    <Grid item xs={12}>
                        <CardViewTextRow
                            title="Amount"
                            value={`${pointsAdded} Stamp${pointsAdded > 1 ? 's' : ''}`}
                        />
                    </Grid>
                )}
                {(!perk || perk.template === AwardTemplate.PSEUDO_CURRENCY) && (
                    <Grid item xs={12}>
                        <CardViewTextRow
                            title="Amount"
                            value={`${pointsAdded} Point${pointsAdded > 1 ? 's' : ''}`}
                        />
                    </Grid>
                )}
            </Grid>
        </ActionCardBase>
    );
};
